import { userLanguageTrackingInitFactory } from '@aca-new/app/shared/factories/user-language-tracking-init.factory';
import { UserLanguageTrackingService } from '@aca-new/app/shared/services/third-party-services/user-language-tracking/user-language-tracking.service';
import { APP_INITIALIZER, FactoryProvider } from '@angular/core';

export const USER_LANGUAGE_TRACKING_INIT_PROVIDER: FactoryProvider = {
  deps: [UserLanguageTrackingService],
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: userLanguageTrackingInitFactory,
};
